// tslint:disable
export enum IntakeType {
    /**
     * @description Intake by phone
     */
    Call = 1,
    /**
     * @description Intake by web
     */
    Web = 2,
    /**
     * @description Intake by document
     */
    Document = 3,
    /**
     * @description Intake by data feed
     */
    Datafeed = 4,
}
(IntakeType as any)['CALL'] = 1;
(IntakeType as any)['WEB'] = 2;
(IntakeType as any)['DOCUMENT'] = 3;
(IntakeType as any)['DATAFEED'] = 4;
